<template>
  <div class="mx-auto table-responsive px-3 tw:max-w-400">
    <table class="table">
      <thead class="tw:text-left tw:text-sm tw:bg-zinc-50 tw:hidden tw:md:table-header-group">
        <tr>
          <th v-if="selectable" class="d-print-none tw:w-px tw:whitespace-nowrap">
            <input type="checkbox"
                   :checked="allSelected"
                   :indeterminate="isIndeterminate"
                   @change="updateAllSelection($event.target.checked)"
            />
          </th>
          <th v-if="showColumn('image')" class="d-none d-print-table-cell d-lg-table-cell"></th>
          <th v-if="showColumn('barcode')">{{ $t('Barcode') }}</th>
          <th v-if="showColumn('brand')">{{ $t('Brand') }}</th>
          <th v-if="showColumn('model')">{{ $t('Model') }}</th>
          <th v-if="showColumn('year')">{{ $t('Year') }}</th>
          <template v-if="showColumn('product-metafields')">
            <th v-for="productMetafield in productMetafields" class="d-none d-lg-table-cell">
              {{ productMetafield.name }}
            </th>
          </template>
          <th v-if="showColumn('size-color')">
            {{ $t('Size') }} - {{ $t('Color') }}
          </th>
          <th v-if="showColumn('references')">
            {{ $t('References') }}
          </th>
          <template v-if="showColumn('equipment-metafields')">
            <th v-for="equipmentMetafield in equipmentMetafields" class="d-none d-lg-table-cell">
              {{ equipmentMetafield.name }}
            </th>
          </template>
          <th v-if="showColumn('condition')" class="d-print-none">{{ $t('Condition') }}</th>
          <th v-if="showColumn('status')" class="d-print-none">{{ $t('Status') }}</th>
          <th v-if="showColumn('parks')" class="d-print-none">{{ $t('Parks') }}</th>
          <th v-if="showColumn('tests')" class="d-print-none">{{ $t('Tests') }}</th>
          <th v-if="showColumn('test-status') || showColumn('actions')" class="d-print-none" colspan="2">&nbsp</th>
        </tr>
      </thead>
      <EquipmentTableRow v-for="equipment in equipments"
                 :key="equipment.id"
                 :equipment="equipment"
                 :is-selected="isSelected(equipment.id)"
                 :selectable="selectable"
                 :productMetafields="productMetafields"
                 :equipmentMetafields="equipmentMetafields"
                 :columns="columns"
                 v-on:selected="$emit('selected', equipment.id)"
                 v-on:deselected="$emit('deselected', equipment.id)"
      >
      </EquipmentTableRow>
    </table>
  </div>
</template>

<script setup>
import { onMounted, provide, ref, toRef } from 'vue';
import EquipmentTableRow from "./EquipmentTableRow.vue";
import useItemSelection from "@/composables/useItemSelection";

const props = defineProps({
  selectable: {
    type: Boolean,
    default: false,
  },
  equipments: {
    type: Array,
    default: () => [],
  },
  equipmentsSelected: {
    type: Array,
    default: () => [],
  },
  productMetafields: {
    type: Array,
    default: () => []
  },
  equipmentMetafields: {
    type: Array,
    default: () => []
  },
  columns: {
    type: Array,
    default: () => [],
  },
});

const showColumn = (name) => props.columns.length === 0 || props.columns.includes(name);

const editingEquipmentId = ref(null);
provide('editingEquipmentId', editingEquipmentId);

const emit = defineEmits(['selected', 'deselected']);

const {
  allSelected,
  isIndeterminate,
  isSelected,
} = useItemSelection({
  items: toRef(props, 'equipments'),
  selectedIds: toRef(props, 'equipmentsSelected'),
});

const updateAllSelection = (checked) => {
  props.equipments.forEach(equipment => {
    if (checked) {
      emit('selected', equipment.id);
    } else {
      emit('deselected', equipment.id);
    }
  });
};

onMounted(() => {
  window.addEventListener("beforeprint", function(event) {
    // Can be used to redirect to a print-friendly version if needed
  });
});
</script>

<style scoped>
  th {
    font-size: 0.9rem;
  }
</style>